import { render, staticRenderFns } from "./DoneQuizzes.vue?vue&type=template&id=2dbdd1bb&scoped=true&"
import script from "./DoneQuizzes.vue?vue&type=script&lang=js&"
export * from "./DoneQuizzes.vue?vue&type=script&lang=js&"
import style0 from "./DoneQuizzes.vue?vue&type=style&index=0&id=2dbdd1bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbdd1bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
